import { FORTEM_URIS } from '@/constants/uris'
import { InstrumentsPage } from '@/pages/instruments/booked-instruments/page'
import { InstrumentsLayout } from '@/pages/instruments/layout'
import { MarketSummaryPage } from '@/pages/instruments/market-summary/page'
import { MarketDataPage } from '@/pages/instruments/marketdata/page'
import { NewInstrumentPage } from '@/pages/instruments/new-instrument/page'
import { TimeSeriesPage } from '@/pages/instruments/time-series/page'
import type { CustomRouteObject, FortemRouteHandle } from '@/router'

export const intsrumentRoutes = [
  {
    path: FORTEM_URIS.INSTRUMENTS.__INDEX__,
    element: <InstrumentsLayout />,
    handle: {
      title: 'Instruments',
    },
    children: [
      { index: true, element: <InstrumentsPage /> },
      {
        path: FORTEM_URIS.INSTRUMENTS.NEW_INSTRUMENT,
        element: <NewInstrumentPage />,
      },
      {
        path: FORTEM_URIS.INSTRUMENTS.TIME_SERIES,
        element: <TimeSeriesPage />,
      },
      {
        path: FORTEM_URIS.INSTRUMENTS.MARKETDATA,
        element: <MarketDataPage />,
      },
      {
        path: FORTEM_URIS.INSTRUMENTS.MARKET_SUMMARY,
        element: <MarketSummaryPage />,
      },
    ],
  },
] satisfies CustomRouteObject<FortemRouteHandle>[]
